import { registerIntercomEventConsumer } from "./intercom";
const consumers = [
    registerIntercomEventConsumer,
];
consumers.forEach(register => register());
